/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 创建订单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  createOrder: order.CreateOrder,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/order/quick-order`,
    data: createOrder,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
